var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame21(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16528_1310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1921 5.091H6.7431V0.642005C6.70564 0.453473 6.60154 0.284734 6.44986 0.16666C6.29819 0.0485856 6.10906 -0.010929 5.9171 -0.000995258C5.72528 -0.0109692 5.53628 0.048405 5.38462 0.166279C5.23296 0.284153 5.12878 0.452657 5.0911 0.641005V5.091H0.642103C0.453756 5.12868 0.285252 5.23287 0.167378 5.38452C0.0495036 5.53618 -0.00987056 5.72519 0.000103375 5.91701C-0.00987056 6.10882 0.0495036 6.29783 0.167378 6.44949C0.285252 6.60114 0.453756 6.70533 0.642103 6.743H5.0911V11.192C5.12878 11.3804 5.23296 11.5489 5.38462 11.6667C5.53628 11.7846 5.72528 11.844 5.9171 11.834C6.10892 11.844 6.29793 11.7846 6.44958 11.6667C6.60124 11.5489 6.70543 11.3804 6.7431 11.192V6.743H11.1921C11.3805 6.70533 11.549 6.60114 11.6668 6.44949C11.7847 6.29783 11.8441 6.10882 11.8341 5.91701C11.8441 5.72519 11.7847 5.53618 11.6668 5.38452C11.549 5.23287 11.3805 5.12868 11.1921 5.091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16528_1310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.834,
    height: 11.834,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame21);
export default __webpack_public_path__ + "static/media/Frame (21).55e9c90a.svg";
export { ForwardRef as ReactComponent };